import { InferenceType } from "@/lib/playground-utils";

export enum Capability {
  VisualQuery = "visual-query",
  Caption = "caption",
  ObjectDetection = "object-detection",
  Pointing = "pointing",
}

export interface PromptProps {
  uploadedImage: string | null;
  imageFile: File | null;
  setInferences: React.Dispatch<React.SetStateAction<InferenceType[]>>;
  inferenceUrl: string;
  variant?: string;
  initialPrompt?: string | null;
  initialSkill?: string | null;
}
